module.exports = __webpack_public_path__ + "static/media/no_mf_orders.3dd9b53d.svg";